module.exports = __webpack_public_path__ + "img/bullet-01.7ea5c81b.svg";